import React from 'react';

export default function GeneralTab({ generalSettings, handleSaveGeneral, loading, setGeneralSettings }) {
  return (
        <div className="glass-card">
          <h2 className="text-xl sm:text-2xl font-semibold text-white mb-6 sm:mb-8">Configurações Gerais</h2>
          <div className="space-y-6 sm:space-y-8">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8">
              <div>
                <label className="block text-base font-medium text-gray-300 mb-3">
                  Nome do Estabelecimento
                </label>
                <input
                  type="text"
                  className="glass-input w-full text-base sm:text-sm"
                  style={{ minHeight: '48px', padding: '12px 16px' }}
                  value={generalSettings.name}
                  onChange={(e) => setGeneralSettings({ ...generalSettings, name: e.target.value })}
                  placeholder="Nome do seu restaurante"
                  data-testid="general-name-input"
                />
              </div>

              <div>
                <label className="block text-base font-medium text-gray-300 mb-3">
                  Subdomínio
                </label>
                <div className="flex items-stretch">
                  <input
                    type="text"
                    className="glass-input flex-1 rounded-r-none text-base sm:text-sm"
                    style={{ minHeight: '48px', padding: '12px 16px' }}
                    value={generalSettings.subdomain}
                    onChange={(e) => setGeneralSettings({ ...generalSettings, subdomain: e.target.value })}
                    placeholder="seurestaurante"
                    data-testid="general-subdomain-input"
                  />
                  <span className="bg-white/5 border border-l-0 border-white/10 px-4 py-3 rounded-r-xl text-gray-400 text-sm flex items-center whitespace-nowrap">
                    .menu.com
                  </span>
                </div>
              </div>

              <div>
                <label className="block text-base font-medium text-gray-300 mb-3">
                  Telefone/WhatsApp
                </label>
                <input
                  type="text"
                  className="glass-input w-full text-base sm:text-sm"
                  style={{ minHeight: '48px', padding: '12px 16px' }}
                  value={generalSettings.phone}
                  onChange={(e) => setGeneralSettings({ ...generalSettings, phone: e.target.value })}
                  placeholder="+55 (00) 00000-0000"
                  data-testid="general-phone-input"
                />
              </div>

              <div>
                <label className="block text-base font-medium text-gray-300 mb-3">
                  Pedido Mínimo (R$)
                </label>
                <input
                  type="number"
                  step="0.01"
                  inputMode="decimal"
                  className="glass-input w-full text-base sm:text-sm"
                  style={{ minHeight: '48px', padding: '12px 16px' }}
                  value={generalSettings.minimum_order}
                  onChange={(e) => setGeneralSettings({ ...generalSettings, minimum_order: parseFloat(e.target.value) })}
                  placeholder="15.00"
                  data-testid="general-minimum-order-input"
                />
              </div>

              <div>
                <label className="block text-base font-medium text-gray-300 mb-3">
                  Tempo de Entrega
                </label>
                <input
                  type="text"
                  className="glass-input w-full text-base sm:text-sm"
                  style={{ minHeight: '48px', padding: '12px 16px' }}
                  value={generalSettings.delivery_time}
                  onChange={(e) => setGeneralSettings({ ...generalSettings, delivery_time: e.target.value })}
                  placeholder="Ex: 30-45 min"
                  data-testid="general-delivery-time-input"
                />
                <p className="text-sm text-gray-500 mt-2">Este tempo será exibido no perfil da loja no menu público</p>
              </div>
            </div>

            <div className="flex justify-end pt-4 sm:pt-6 border-t border-white/10">
              <button
                onClick={handleSaveGeneral}
                disabled={loading}
                className="glass-button-primary w-full sm:w-auto"
                style={{ minHeight: '48px', padding: '12px 32px', fontSize: '16px' }}
                data-testid="general-save-button"
              >
                {loading ? 'Salvando...' : 'Salvar Configurações'}
              </button>
            </div>
          </div>
        </div>
  );
}
